<!--
 * @Author: your name
 * @Date: 2020-12-06 19:29:37
 * @LastEditTime: 2020-12-06 19:35:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/milkplan/components/PlanTimeStatus/index.vue
-->
<template>
  <!-- 配送计划期数信息 -->
  <div :class="{ milk_date_bg: overBg }" class="milk_date">
    <div class="font14 font_weight500 colo0 line_height_20">
      <span>第 {{ item.seqNo }} 期</span>
      <span class="font12 font_weight400 colo038 line_height_20"
        >/共{{ getDistributionPlan.totalPeriods }}期</span
      >
    </div>
    <div class="status_flex">
      <div
        v-if="item.afterInfo"
        class="font12 font_weight500 colof00 refund_det text_left"
      >
        {{ item.afterInfo }}<span class="span_mr">|</span>
      </div>
      <div
        v-if="!(getDistributionPlan.status === 1 && item.status === 0)"
        :class="{
          paln_status1: item.status === 2
        }"
        class="font12 font_weight400 paln_status"
      >
        {{ item.status | statusDet }}
      </div>
      <div
        v-if="getDistributionPlan.status === 1 && item.status === 0"
        class="font12 font_weight400 paln_status paln_status1"
      >
        已暂停配送
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    overBg: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    getDistributionPlan() {
      return this.$store.getters.getDistributionPlan;
    }
  },
  data() {
    return {
      sendStatus: ["正在配送", "等待配送", "已完成配送"]
    };
  },
  filters: {
    statusDet(status) {
      switch (status) {
        // (0:未开始,:1正在配送,2:已完成
        case 0:
          return "等待配送";
        case 1:
          return "正在配送";
        case 2:
          return "已完成配送";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.milk_date {
  display: flex;
  justify-content: space-between;
  padding: 14px 12px;
  .paln_status {
    color: #bf9264;
  }
  .paln_status1 {
    color: rgba(0, 0, 0, 0.87) !important;
  }
}
.milk_date_bg {
  border-radius: 6px 6px 0px 0px;
  background: rgba(0, 0, 0, 0.1);
}
.status_flex {
  display: flex;
  align-items: center;
  .span_mr {
    margin: 0 8px;
    color: rgba(0, 0, 0, 0.3);
  }
}
</style>
